import { INITIALIZE_FORM } from '../actionTypes';
import { createContactModalActions } from '../reducer';

export default (values) => createContactModalActions[INITIALIZE_FORM](values);
